import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "snippet",
  "use": "snippet-usage",
  "viewBox": "0 0 118.24 117.47",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 118.24 117.47\" id=\"snippet\"><style>#snippet .st0{fill:#929397}</style><path class=\"st0\" d=\"M79.81 60.82l-11.77 5.8v4.79l16.06-9.14v-3.13l-16.06-8.49v4.53zM34 61.24l11.77-5.8v-4.79l-16.05 9.14v3.13l16.05 8.49v-4.54zM49.24 77.29h4.6L65.15 44h-4.6z\" /><path d=\"M95.21 45.74V32.25v-2.1-1.19c0-.02 0-.05-.01-.07-.01-.02-.03-.04-.04-.05-.3-.3-.59-.61-.89-.91-.81-.83-1.62-1.67-2.43-2.5-1.11-1.15-2.23-2.29-3.34-3.44-1.22-1.26-2.45-2.52-3.67-3.78-1.14-1.17-2.28-2.35-3.42-3.52-.86-.89-1.73-1.77-2.59-2.66-.29-.3-.57-.62-.87-.92-.31-.3-.57-.4-1-.37-.95.06-1.91.06-2.87.06H22.55s-3.79-.1-3.85 4.41c0 25.44.09 50.89-.07 76.33-.01 2.07-.02 4.14-.01 6.22.01 1.92-.14 3.89.6 5.69.01.03.03.07.04.1 1.17 2.71 4.01 3.22 6.66 3.23 23.1.04 46.2-.03 69.3 0-.01-20.34-.01-40.69-.01-61.04z\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"6\" stroke-miterlimit=\"10\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/snippet.svg
// module id = RXWN
// module chunks = 39 44